import { render, staticRenderFns } from "./SeasonsPage.vue?vue&type=template&id=61fa38d2&"
import script from "./SeasonsPage.vue?vue&type=script&lang=js&"
export * from "./SeasonsPage.vue?vue&type=script&lang=js&"
import style0 from "./SeasonsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports